import * as Request from '../Request';

const TenantAnalysis = {
  // 顶部统计banner（租户总量/资源消耗/二次续费客户/总使用人数）
  getBanner: (data) => {
    return Request.get('/tenant/analysis/banner', data);
  },
  // 近期到期租户（剩余90天内到期，按有效期升序）
  getExpireUnits: (data) => {
    return Request.get('/tenant/analysis/expire-units', data);
  },
  // 租户类型占比（集团租户/一般租户）
  getTenantType: (data) => {
    return Request.get('/tenant/analysis/tenant-type', data);
  },
  // 有效期年度分布
  getExpireYearDist: (data) => {
    return Request.get('/tenant/analysis/expire-year-dist', data);
  },
  // 资源使用分析（账户数/AI识别/短信额度总使用量）
  getResourceUse: (data) => {
    return Request.get('/tenant/analysis/resource-use', data);
  },
  // 资源使用Top5（AI/短信/人员数）
  getResourceTop5: (data) => {
    return Request.get('/tenant/analysis/resource-top5', data);
  }
}
export default TenantAnalysis
